<template>
  <div class="card cardimage h-100">
    <div class="card-body">           
      <div class="row h-100">
        <div class="col-lg-12 file-section">
          <DocumentList
            :documents='resources'
            :manifest-id='manifestId'
            @show-error-notification='showErrorNotification'
          />
        </div>
        <div class="col-lg-12 text-end mt-3">
          <LoadingButton :disable-button='isLoading' :text='isLoading ? loadingString : importString' @import-file='importFile' />
          <input ref="manifestInputFile" type="file" class="d-none" />
        </div>
      </div>
    </div>
    <div class="position-fixed top-8 end-2 z-index-2">
      <soft-snackbar
        :show="showNotification"
        :title="notificationInfo.title"
        :description="notificationInfo.message"
        :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
        :color="notificationInfo.status=='success'?'success':'danger'"
        @close-handler="showNotification = !showNotification"
      />
    </div>
  </div>
</template>
<script>

import LoadingButton from "@/hotaka/components/LoadingButton.vue";
import SoftSnackbar from "@/components/SoftSnackbar.vue";
import DocumentList from "./DocumentList.vue";

export default {
  name: "FileVisualizer",
  components: {
    DocumentList,
    LoadingButton,
    SoftSnackbar,
  },
  props: {
    manifestId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      resources: [],
      isLoading: false,
      notificationInfo:{
        title: '',
        message: '',
        status: 'danger'
      },
      showNotification: false,
    }
  },
  computed: {
    uploadStatus() {
      return this.$store.state.manifiest.uploadResource.status;
    },
    deleteStatus() {
      return this.$store.state.manifiest.deleteResource.status;
    },
    manifestResources() {
      return this.$store.state.manifiest.manifestResources.status;
    },
    loadingString() {
      return this.$t('key_loading');
    },
    importString() {
      return this.$t('key_import');
    }
  },
  watch:{
    manifestResources(newValue) {
      if(newValue['loaded']) {
        const resources = this.$store.state.manifiest.manifestResources.data
        this.resources = [ ...resources ]
      }
    },
    uploadStatus(newValue) {
      if(newValue['uploaded']){
        this.isLoading = false
        let entity = this.$store.state.manifiest.uploadResource.data
        this.$store.commit("manifiest/appendResource", entity);
      }

      if(newValue['error']){
        this.isLoading = false
        const { error } = newValue
        if (error.status == 'KO') {
          this.showErrorNotification(error['error'])
        } else {
          this.showErrorNotification('Error al cargar el recurso')
        }
      }
    },
    deleteStatus(newValue) {
      if(newValue['deleted']){
        this.isLoading = false
        let fileName = this.$store.state.manifiest.deleteResource.fileName
        this.$store.commit("manifiest/popResource", fileName);
      }
    },
  },
  mounted() {
    this.$store.commit("manifiest/loadResources", this.manifestId);

    if (this.$refs.manifestInputFile) {
      this.$refs.manifestInputFile.onchange = (event) => {
        if (event.target.files[0]) {
          this.isLoading = true
          let dataForm = new FormData();
          dataForm.append('file', event.target.files[0]);

          this.$store.commit("manifiest/uploadResource", { entityId: this.manifestId,  dataForm: dataForm });
        }
      }
    }
  },
  methods: {
    importFile() {
      this.$refs.manifestInputFile.click()
    },
    showErrorNotification(message) {
      this.notificationInfo = {
        title: 'Ups! Lo Sentimos',
        message: message,
        status: 'danger'
      }
      this.showNotification = true;
      this.closeNotification();
    },
    closeNotification(){
      const self= this;
      setTimeout(function () {
          self.showNotification = false
      }, 6000);
    },
  }
}
</script>
<style scoped lang="scss">
.center-vertical {
  display: table-cell;
  vertical-align: middle !important;
  width: 2rem;
  height: 2rem;
  text-align: center;
}
.cardimage {
  position: inherit !important;
}

.icon-white {
  color: white !important;
}
.icon-primary {
  color: #4A7062 !important;
}

.modal-content1 {
  width: 55rem !important;
  margin-left: 7%
}

.modal-body1 {
  height: 550px !important;
  overflow-y: hidden !important
}

.file-section {
  padding: 10px;
  border: 4px dotted #c1c8d5;
  border-radius: 10px;
  height: 20rem;
  overflow-y: auto;
}
</style>